import src from "IMAGE";
export default { src, width: 307, height: 307, blurWidth: 0, blurHeight: 0};
